import { FlexTemplateRenderer, FlexTemplateRendererContextProvider } from 'flex-template-renderer-react';
import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

import { componentLibrary } from 'components/infosite/template-components';
import { singleUnitTemplateLarge, singleUnitTemplateSmall } from 'components/templates/single-offer';

export class SingleOfferTemplate extends React.Component {
  public render() {
    return (
      <FlexTemplateRendererContextProvider library={componentLibrary}>
        <Viewport>
          <ViewSmall>
            <FlexTemplateRenderer template={singleUnitTemplateSmall} />
          </ViewSmall>
          <ViewLarge>
            <FlexTemplateRenderer template={singleUnitTemplateLarge} />
          </ViewLarge>
        </Viewport>
      </FlexTemplateRendererContextProvider>
    );
  }
}
